import { Button, Modal, SimpleGrid, Stack } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconEye } from "@tabler/icons-react";
import { ModalFooter } from "../ModalFooter/ModalFooter";

interface StackOrModalProps {
  children: React.ReactNode;
  elementText: string;
  numElements: number;
  modalColumns?: number;
}

function StackOrModal({
  children,
  elementText,
  numElements,
  modalColumns = 3
}: StackOrModalProps) {
  const [opened, { open, close }] = useDisclosure(false);

  if (numElements < 4) {
    return <Stack>{children}</Stack>;
  }

  return (
    <>
      <Button
        aria-label={`${elementText} anzeigen`}
        color="neutral.8"
        rightSection={<IconEye color="#333" />}
        size="xs"
        variant="transparent"
        onClick={open}
      >
        {numElements} {elementText}
      </Button>
      <Modal opened={opened} size="auto" title={elementText} onClose={close}>
        <SimpleGrid cols={modalColumns} spacing="sm">
          {children}
        </SimpleGrid>
        <ModalFooter>
          <Button onClick={close}>Schließen</Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export { StackOrModal, StackOrModalProps };
